// extracted by mini-css-extract-plugin
export default {"header":"ConfirmActionDialog_header__XfA7D"};